// extracted by mini-css-extract-plugin
export default {"logout":"logout_logout__0Ebkk"};